import {Component} from '@angular/core';
import {Field} from '../../../../../model/field.model';
import {Line} from '../../../../../model/line.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../../../../state.service';
import {TruffleFound} from '../../../../../model/truffelFound.model';
import {Tree} from '../../../../../model/tree.model';

@Component({
    selector: 'app-add-truffle',
    templateUrl: './add-truffle.component.html',
    styleUrls: ['./add-truffle.component.css'],
    standalone: false
})
export class AddTruffleComponent {
  truffleFound = new TruffleFound();
  submitted = false;
  field: Field;
  line: Line;
  tree: Tree;
  qualities = ['Erste Klasse', 'Zeite Klasse', 'Unbrauchbar'];

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.field && !this.stateService.line && !this.stateService.tree) {
      this.router.navigate( ['field']);
    }
    this.field = this.stateService.field;
    this.line = this.stateService.line;
    this.tree = this.stateService.tree;
  }

  onSubmit() {
    this.truffleFound.id = this.tree.truffleFounds ? this.tree.truffleFounds.length + 1 : 1;
    this.field.lines[this.line.id - 1].trees[this.tree.id - 1].truffleFounds.push({...this.truffleFound});
    this.submitted = true;
    this.stateService.addTruffle(this.field);
    this.router.navigate(['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.tree.id]);
  }
}
